import React from 'react'

import DefaultEntityConsult from 'components/form/DefaultEntityConsult'

// import { fetchArray } from 'entity';
// import Cliente from 'entity/Cliente';
import Insumo from 'entity/Insumo'

// import { usePerfil } from 'useAuth';

export default function InsumoConsulta() {


    return (
        <DefaultEntityConsult
            EntityClass={Insumo}
            initialFilters={{ status: "ATIVO" }}
            titulo="Insumos"
            routeForm="_insumo"
            showEdit={true}
            showDelete={true}
        />
    )
}
